import BN from 'bn.js';
import * as React from 'react';

import { ClaimerBlock } from '~features/claimer/ClaimerBlock';
import { usePool } from '~features/pools';

import { Distribution, PoolToken } from '../../types';
import { ListItem } from '../PoolSecondaryBlock/InfoListItem';
import { Title } from '../PoolSecondaryBlock/UI';
import { DistributionType } from './DistributionType';

export function DistributionSection({
  distribution,
  token,
  poolBalance,
}: {
  distribution: Distribution;
  token: PoolToken;
  poolBalance: BN;
}) {
  const { pool } = usePool();

  return (
    <div>
      <Title>{distribution.title || 'Distribution'}</Title>

      <ListItem label="Distribution">
        <DistributionType distribution={distribution} token={token} />
      </ListItem>

      {distribution.vesting && (
        <ListItem label="Vesting">{distribution.vesting}</ListItem>
      )}

      <div className="mt-3">
        <ClaimerBlock
          distribution={distribution}
          token={token}
          poolBalance={poolBalance}
          pool={pool}
        />
      </div>
    </div>
  );
}
